// Area: health (owner platform-contracts; frozen in wave 2).
import { z } from 'zod';
import { defineContract } from '../define';

export const HealthDTO = z.object({
  status: z.literal('ok'),
  version: z.string(),
  db: z.object({ ok: z.boolean(), latencyMs: z.number().nonnegative() }),
  /** Cache backend of this node (`memory` or `postgres`). */
  cache: z.string(),
});
export type HealthDTO = z.infer<typeof HealthDTO>;

export const healthContract = defineContract({
  method: 'GET',
  path: '/health',
  public: true,
  response: HealthDTO,
  summary: 'Liveness and database connectivity',
});
